import {
    QUESTIONS_ROUTE,
    QUIZZES_LIST_ROUTE,
    QUESTION_COPY_ROUTE,
    QUESTION_COVER_ROUTE,
    GET_HATCH_QUESTIONS_ROUTE,
    CALENDAR_QUESTION_PIN_ROUTE,
    QUESTION_DROP_ROUTE
} from './constants';

import http from '../../../utils/httpService';


/**
 *
 * @param hatchID
 * @param questionType
 * @param questionText
 * @param langID
 */
const requestCalendarQuestionCreation = ( hatchID, questionType, questionText, langID ) => {
    const questionBody = {
        hatch_id: hatchID,
        type: questionType,
        text: questionText,
        lang_id: langID
    };
    return http.request( QUESTIONS_ROUTE, 'POST', questionBody );
};
/**
 *
 * @param questionID
 */
const requestDeleteCalendarQuestion = questionID => {
    const route = QUESTIONS_ROUTE + `/${ questionID }`;
    return http.request( route, 'DELETE' );
};
/**
 *
 */
const requestCalendarQuizzesList = () => {
    return http.request( QUIZZES_LIST_ROUTE, 'GET' );
};
/**
 *
 * @param questionID
 * @param hatchID
 */
const requestCalendarQuestionCopy = ( questionID, hatchID ) => {
    const body = {
        hatch_id: hatchID
    };
    const route = QUESTION_COPY_ROUTE + `/${ questionID }`;
    return http.request( route, 'POST', body );
};
/**
 *
 * @param questionID
 * @param localizationID
 * @param image
 * @param screenType
 */
const requestQuestionCoverUpload = ( questionID, localizationID, image, screenType ) => {
    const route = QUESTION_COVER_ROUTE + `/${ questionID }`;
    const requestBody = new FormData();
    const isDesktop = screenType === 'Desktop';

    requestBody.append( 'isDesktop', isDesktop );
    requestBody.append( 'image', image );
    requestBody.append( 'question_localization_id', localizationID );

    return http.request( route, 'POST', requestBody, true );
};
/**
 *
 * @param hatchID
 */
const requestGetHatchQuestions = ( hatchID ) => {
    const route = GET_HATCH_QUESTIONS_ROUTE + `/${ hatchID }`;

    return http.request( route, 'GET' );
};
/**
 *
 * @param questionID
 * @param questionPiece
 */
const requestCalendarQuestionUpdate = ( questionID, questionPiece ) => {
    const route = QUESTIONS_ROUTE + `/${ questionID }`;
    return http.request( route, 'PUT', questionPiece );
};
/**
 *
 * @param localizationID
 */
const requestHatchQuestionPin = ( localizationID ) => {
    const route = CALENDAR_QUESTION_PIN_ROUTE + `/${ localizationID }`;
    return http.request( route, 'POST' );
};
/**
 *
 * @param id
 * @param localizationId
 */
const requestupdateCalendarQuestionCover = ( id, localizationId ) => {
    const route = QUESTION_COVER_ROUTE + `/${ id }`;
    return http.request( route, 'DELETE', { question_localization_id: localizationId } );
};
/**
 *
 * @param id
 * @param result
 */
const requestQuestionDrop = ( id, result ) => {
    const route = QUESTION_DROP_ROUTE + `/${ id }`;
    return http.request( route, 'POST', result );
};
export {
    requestQuestionDrop,
    requestCalendarQuestionCreation,
    requestDeleteCalendarQuestion,
    requestCalendarQuizzesList,
    requestCalendarQuestionCopy,
    requestQuestionCoverUpload,
    requestCalendarQuestionUpdate,
    requestGetHatchQuestions,
    requestHatchQuestionPin,
    requestupdateCalendarQuestionCover
};
